import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";

const IncomeChart = ({ salesData }) => {
    const generateLastSixMonthsData = () => {
        let months = [];
        let values = [];
        const currentDate = new Date();

        for (let i = 5; i >= 0; i--) {
            const monthDate = new Date();
            monthDate.setMonth(currentDate.getMonth() - i);
            const month = monthDate.toLocaleString("default", { month: "long" });

            months.push(month);
            values.push(0);
        }

        return { months, values };
    };

    const [options, setOptions] = useState({
        chart: { id: "income-bar" },
        dataLabels: {
            enabled: true,
        },
        xaxis: { categories: [] } // Will be updated dynamically
    });

    const [series, setSeries] = useState([{ name: "Income", data: [] }]);

    useEffect(() => {
        let months, values;

        if (salesData && Object.keys(salesData).length > 0) {
            // Use API sales data
            months = Object.keys(salesData);
            values = Object.values(salesData);
        } else {
            // Use last 6 months with dummy values
            ({ months, values } = generateLastSixMonthsData());
        }

        setOptions(prevOptions => ({ ...prevOptions, xaxis: { categories: months } }));
        setSeries([{ name: "Income", data: values }]);
    }, [salesData]);

    return (
        <div className="app">
            <div className="row">
                <div className="mixed-chart">
                    <Chart options={options} series={series} type="line" width="100%" height="400" />
                </div>
            </div>
        </div>
    );
};

export default IncomeChart;
